import webClient from "../config/api.config";
import i18n from "../i18n";
import { BulkStaticDoctorProfileImportRequest } from "../types/staticDoctorProfile.definition";

export function bulkImportStaticDoctorProfiles(
  data: BulkStaticDoctorProfileImportRequest
) {
  return webClient.request({
    method: "post",
    url: `doctors/static-profiles/bulk`,
    data,
  });
}

export function getAllStaticDoctorProfiles() {
  return webClient.request({
    method: "get",
    url: `doctors/static-profiles`,
  });
}

export function inviteFromStaticDoctorProfile(id: number) {
  return webClient.request({
    method: "post",
    url: `doctors/static-profiles/${id}/invite`,
    params: { lang: i18n.language || "fr" },
  });
}

/**
 * MED-1474: dry-run the bulk import. Always answers 200 with the per-row errors the
 * real import would raise, so the preview can show them before anything is written.
 */
export function validateBulkImportStaticDoctorProfiles(
  data: BulkStaticDoctorProfileImportRequest
) {
  return webClient.request({
    method: "post",
    url: `doctors/static-profiles/bulk/validate`,
    data,
  });
}
